import { SSIUplineResponse } from "../../../services/SSIUpline/ssiUplineAPI.types";
import { OutOfProgramWrapper, Row } from "./OutOfProgramWrapper/OutOfProgramWrapper";
import "./OutOfProgramSection.scss";
import { useEffect, useRef } from "react";
import { ErrorPage, ERROR_TYPE, IconType } from "../../ErrorPage/ErrorPage";
import { track } from "../../../common/util/tealium";

interface Props {
  ssiUplineData: SSIUplineResponse;
  isLoading: boolean;
  selectedAboNumber: string;
}

export const OutOfProgram = ({ ssiUplineData, isLoading, selectedAboNumber }: Props) => {
  const scrollRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [selectedAboNumber]);

  const outOfProgramRows: Row[] = ssiUplineData?.OutOfProgram?.ABOs.map((row): Row => {
    return {
      AboName: row.AboName,
      AboNum: row.Abo,
      Aff: row.Aff,
      Requirements: row.Requirements,
      EligibilityWindow: row.EligibilityWindow,
      SponsorName: row.SponsorName,
      SponsorNum: row.SponsorABO,
      IsHighlighted: row.Abo === selectedAboNumber,
      scrollRef: row.Abo === selectedAboNumber ? true : false,
    };
  });

  if ((!ssiUplineData?.OutOfProgram || outOfProgramRows?.length === 0) && !isLoading) {
    return (
      <div className="OutOfProgramSection__error">
        <ErrorPage
          errorType={ERROR_TYPE.NO_DOWNLINES}
          iconType={IconType.SearchCriteria}
          tealiumTrackFunction={() => track("view", "", "out-of-program_tab", "ssi_upline_report", "no_downlines", "")}
        />
      </div>
    );
  }

  return (
    <div className="OutOfProgramSection">
      <div className="OutOfProgramSection__section">
        <OutOfProgramWrapper rows={outOfProgramRows} isLoading={isLoading} selectedAboNumber={selectedAboNumber} />
      </div>
    </div>
  );
};
